import { getTenant } from "@/TENANT_CONFIGS";
import { isFeatureDisabledOnProd } from "@/utils/isFeatureDisabledOnProd";

/**
 * The ONE read of the content-collab switch: the tenant's deployment flag
 * (deployment._ContentCollabEditingMode — on by default for self-managed
 * tenants) minus the prod gate (FEATURES_DISABLED_ON_PROD: contentCollabEditing).
 *
 * Every FE decision that hangs on "is this a collab tenant?" — opening the
 * live session, the born-published publishing flow, retiring the legacy
 * per-annotation lock — goes through here, so the gate can never apply to
 * one surface and not another. okf-be's rejectLegacyLifecycleOnCollabTenants
 * applies the same two checks server-side.
 */
export const isContentCollabEnabled = (platformConfigs) => {
  if (!platformConfigs?.deployment?._ContentCollabEditingMode?.enable) return false;
  return !isFeatureDisabledOnProd("contentCollabEditing", {
    disabledFeatures: platformConfigs?.FEATURES_DISABLED_ON_PROD || [],
    isProd: import.meta.env.VITE_ENV === "prod",
    tenant: getTenant(),
  });
};
